export enum DirectorTableColumn {
  NIVEL = 'Nivel',
  CAMPUS = 'Campus',
  NOMBRE = 'Nombre',
  ESTATUS = 'Estatus',
}
